import { FC, useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { FormDocumentDropZone } from '../../../../../components/document-drop-zone/index';
import { useReactForm } from '../../../../../hooks/index';
import { FormControlButtons } from '../components/form-control-buttons';
import { PerkFormSchema, perkFormSchema, PHOTO_IMAGE_ACCEPT } from '../form.validation';
import { PerkStepFormProps } from './steps.types';

export const StepFive: FC<PerkStepFormProps> = ({
  onSubmit,
  handlePrevStep,
  patchStep,
  defaultData: { stepFive },
}) => {
  const {
    control,
    formState: { isValid },
    handleSubmit,
    clearErrors,
    setError,
    reset,
  } = useReactForm({
    schema: perkFormSchema.shape.stepFive,
  });

  useEffect(() => {
    if (!stepFive?.logo?.docLink && !stepFive?.banner?.docLink) return;
    reset(stepFive);
  }, [stepFive, reset]);

  const submitHandler = (data: PerkFormSchema['stepFive']) => {
    onSubmit('stepFive', data);
  };

  const values = useWatch({ control });

  useEffect(() => {
    const id = setTimeout(() => {
      patchStep({ stepFive: values });
    }, 500);

    return () => clearTimeout(id);
  }, [patchStep, values]);

  return (
    <>
      <div className="invisible-y-scroll flex h-full flex-col gap-4">
        <FormDocumentDropZone
          acceptFileFormats={PHOTO_IMAGE_ACCEPT}
          clearErrors={clearErrors}
          control={control}
          description="200 x 200px - Jpeg, png or svg - Maximum per file size 10 MB"
          maxUploads={1}
          name="logo"
          placeholder="Logo"
          schema={perkFormSchema.shape.stepFive.shape.logo}
          setError={setError}
        />
        <FormDocumentDropZone
          acceptFileFormats={PHOTO_IMAGE_ACCEPT}
          clearErrors={clearErrors}
          control={control}
          description="900 x 250px - Jpeg, png or svg - Maximum per file size 10 MB"
          maxUploads={1}
          name="banner"
          placeholder="Banner"
          schema={perkFormSchema.shape.stepFive.shape.banner}
          setError={setError}
        />
      </div>
      <FormControlButtons
        disabled={!isValid || !values.banner?.docLink || !values.logo?.docLink}
        handleNext={handleSubmit(submitHandler)}
        handlePrev={handlePrevStep}
        onFinalStep
      />
    </>
  );
};
